<div class="common-ui-lib-status-ui-card-eric-error-page">

    <h2 class="mb-5x">
        {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.TITEL' | translate }}
    </h2>

    <div *ngIf="ericResponse && (frontendDocument.status === 'created'|| frontendDocument.status === 'sending_error')">
        <div *ngIf="ericResponse.result !== 0">
            <common-ui-eric-response
                    (ericResponseSelected)="handleEricErrorResponse($event)"
                    [data]="ericResponse">
            </common-ui-eric-response>
        </div>
        <div *ngIf="ericResponse.result === 0 && !sendPending && frontendDocument.status !== 'sending_error'">
            <h5 class="mb-3x" id="antragVersandbereit">
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.VERSANDBEREIT' | translate }}
            </h5>
        </div>
    </div>

    <div class="flex-container" *ngIf="frontendDocument.status === 'sending_successful'">
        <span class="icon icon-svg icon-fi-success"></span>
        <div class="text-container">
            <p class="boldText">
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.ERFOLGREICHE_UEBERMITTLUNG.TEXT_1' | translate }}
                {{frontendDocument.transfer_date | date:'dd.MM.yyyy'}}
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.ERFOLGREICHE_UEBERMITTLUNG.TEXT_2' | translate }}
                {{frontendDocument.transfer_date | date:'HH:mm'}}
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.ERFOLGREICHE_UEBERMITTLUNG.TEXT_3' | translate }} </p>
            <p class="marginText">{{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.UEBERMITTLUNGSDETAILS' | translate }}</p>
        </div>
    </div>

    <div class="flex-container" *ngIf="frontendDocument.status === 'sending_error' && !sendPending">
        <span class="icon icon-svg icon-fi-fehler"></span>
        <div class="text-container">
            <p class="boldText">
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.FEHLERHAFTE_UEBERMITTLUNG.TEXT_1' | translate }}
            </p>
            <p class="marginText">
                {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.FEHLERHAFTE_UEBERMITTLUNG.TEXT_2' | translate }}
            </p>
        </div>
    </div>

    <div *ngIf="sendPending" class="flex-container">
        <div id="sendPendingLoader" class="mt-1x">
            <common-ui-loader [position]="'relative'" [size]="'lg'"></common-ui-loader>
        </div>
        <p id="loading-text" class="loading-text">
            {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.WIRD_VERSENDET' | translate}}
        </p>
    </div>

    <div class="btn-bar save-btn mt-1hx mb-1hxt">
        <button id="showPreviewButton" class="btn"
                (click)="displayPreview()" *ngIf="ericResponse?.result === 0 && !sendPending && !readonly || readonly
          && (frontendDocument.status === 'sending_successful'  || frontendDocument.status === 'sending_finalized')">
            {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.VORSCHAU' | translate }}
        </button>
        <button id="navigatePrevButton" class="btn btn-default"
                *ngIf="!sendPending && frontendDocument.status !== 'sending_error'" [routerLink]="backButtonRoute">
            {{ 'COMMON_UI.NAVIGATION.ZURUECK_BUTTON' | translate }}
        </button>
        <button id="toOverview" class="btn"
                (click)="toOverview()" *ngIf="readonly || frontendDocument.status === 'sending_error' || sendPending"
                [class.btn-default]="frontendDocument.status === 'sending_error'"
                [class.btn-primary]="frontendDocument.status !== 'sending_error'">
            {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.ZUR_UEBERSICHT' | translate }}
        </button>
        <common-ui-fragebogen-senden (sending)="send()" [hasAttachments]="this.hasAttachments" class="btn" *ngIf="ericResponse?.result === 0 && !readonly && !sendPending" [readonly]="readonly" context="" [disabled]="sendPending">
        </common-ui-fragebogen-senden>
    </div>

</div>
